module.exports = __webpack_public_path__ + "img/1 (54).bfe9d4bb.png";